import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Stack from "@mui/material/Stack";
import * as React from "react";
import { IMaskInput } from "react-imask";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  maxLength?: number;
}

const TextMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    let maxLength = 20;
    return (
      <IMaskInput
        {...other}
        mask="00000000000000000000"
        definitions={{
          "#": /^[1-6]\d{0,maxLength}$/,
        }}
        inputRef={ref}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  }
);

export default function CustomAccountNumberTextField({ ...props }) {
  const {
    label,
    name,
    defaultValue,
    onChange,
    onBlur,
    helperText,
    required,
    className,
  } = props;
  const [error, setError] = React.useState(false);
  const [values, setValues] = React.useState(defaultValue?.toString() || "");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };
  const handleBlur = () => {
    if (required) {
      if (values == "") {
        setError(true);
      } else {
        setError(false);
      }
    } else {
      setError(false);
    }

    if (onBlur) {
      onBlur();
    }
  };
  let helperTextValue = helperText?.toString() || "This field is required";
  if (helperText === "no") {
    helperTextValue = "";
  }
  return (
    <Stack direction="row" spacing={2}>
      <FormControl variant="standard">
        {label && (
          <InputLabel htmlFor="formatted-text-mask-input">{label}</InputLabel>
        )}
        <OutlinedInput
          sx={{
            "& input": {
              // padding: "8.5px 14px"
              padding: "12px 14px",
            },
          }}
          id={name}
          name={name}
          value={values}
          onChange={handleChange}
          onBlur={handleBlur}
          error={error}
          // helperText={error ? helperTextValue : null}
          inputProps={{ name: name, id: name }}
          inputComponent={TextMaskCustom as any}
          className={className}
        />
        {error && helperTextValue && (
          <FormHelperText sx={{ color: "#d32f2f", marginLeft: "14px" }}>
            {helperTextValue}
          </FormHelperText>
        )}
      </FormControl>
    </Stack>
  );
}
